import React, { useEffect, useState, } from 'react';
import { Link, } from 'react-router-dom';

import Swal from 'sweetalert2';
import axios from 'axios';
import $ from 'jquery';

import useAuth from '../../controllers/users/useAuth';

import {
    checkIfUserIsMaster, dataTableLanguaje, responseGet, globalSettings, styles, sendMessageCloseCurrentWindowAsync, buttonProcessGet, awaitDelay, processEvaluateGet,
    isUndNullEmp, languageObjGet, LoadingSection,
} from '../../helpers/settings';

import { roleModelGet } from '../../models/roles/role';
import RolesAddEdit from './RolesAddEdit';
import Menu from '../main/Menu';
import { GlobalFormats } from '../../classes/main/globalFormats';

const currentMethod = 'Roles';

const { app, colors, html, icons, images, labels, messages, react, roles, } = globalSettings;
const { backend, } = app;
const { html: reactHtml, sweetAlert2 } = react;

export default function Roles({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let headerObj = {};
    const dtRolesId = 'dtRoles';
    const auth = useAuth();
    //const history = useHistory();
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: '', subMethod: '', })?.result;
    const [showModal, setShowModal] = useState(false);
    const [dtRowIndex, setDtRowIndex] = useState(0);
    const [processType, setProcessType] = useState();
    const [role, setRole] = useState({});
    const [showLoading, setShowLoading] = useState({ roles: true });
    //const [showData, setShowData] = useState(false);
    const [btnAddDisable, setBtnAddDisable] = useState(true);
    //#endregion variables

    //#region others
    const controls = {
        buttons: {
            // save: {
            //     id: 'btnCreate',
            //     className: 'btn btn-outline-warning mx-1',
            // },
            // back: {
            //     id: 'btnBack',
            //     className: '',
            // },
            // close: {
            //     id: 'btnClose',
            //     className: 'close btn-danger fas fa-window-close',
            // },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            roles: {
                buttons: {
                    add: {
                        className: 'btn btn-outline-success float-right btn-sm',
                        id: 'btndtRolesIdAdd',
                    },
                    delete: {
                        className: 'btn btn-outline-danger float-right btn-sm mx-1',
                        id: 'btndtRolesIdDelete',
                    },
                },
                icons: {
                    add: {
                        id: 'icondtRolesIdAdd',
                        className: icons?.plusCircle,
                    },
                    delete: {
                        id: 'icondtRolesIdDelete',
                        className: icons?.trash,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtRolesId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtRolesId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    add: {
                        id: 'spdtCoinsIdAdd',
                        className: '',
                    },
                    delete: {
                        id: 'spdtCoinsIdDelete',
                        className: '',
                    },
                },
            },
        },
        icons: {
            // save: {
            //     id: 'icoSave',
            //     className: icons?.save,
            // },
            // back: {
            //     id: 'icoBack',
            //     className: icons?.arrowCircleLeft,
            // },
            // close: {
            //     id: 'icoClose',
            //     className: icons?.plusCircle,
            // },
        },
        inputs: {
            // user: {
            //     id: 'inputUser',
            //     className: 'form-control bg-transparent',
            // },
            // title: {
            //     id: 'inputTitle',
            //     className: 'form-control bg-transparent',
            // },
            // comment: {
            //     id: 'inputComment',
            //     className: 'form-control',
            // },
            // statusComment: {
            //     id: 'inputStatusComment',
            //     className: 'form-control bg-transparent text-black',
            // },
        },
        selects: {
            // apartment: {
            //     id: 'selApartmet',
            //     className: 'form-select',
            // },
            // title: {
            //     id: 'selTitle',
            //     className: 'form-select',
            // },
            // icon: {
            //     id: 'selIcon',
            //     className: 'form-select',
            // },
            // status: {
            //     id: 'selStatus',
            //     className: 'form-select',
            // },
        },
        spinners: {
            // save: {
            //     id: 'spSave',
            //     className: '',
            // },
            // back: {
            //     id: 'spBack',
            //     className: '',
            // },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region methods (roles)
    const roleAddGetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'roleAddGetAsync';
        let response = responseGet();
        try {
            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            setRole(
                roleModelGet({
                    userId: auth?.user?.uid
                })
            );
            setProcessType(0);

            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            setShowModal(true);

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const roleEditGetAsync = async ({
        id = '',
        description = '',
        rowIndex = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'roleEditGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ roles: true, })

            //#region role get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlRoles}/${id}`
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ roles: false, })
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            setProcessType(1);
            setDtRowIndex(rowIndex);
            setRole(response?.result || {});
            //#endregion role get

            setShowModal(true);
            setShowLoading({ roles: false, })
        } catch (ex) {
            setShowLoading({ roles: false, })
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const roleDeleteGetAsync = async ({
        id = '',
        description = '',
        rowIndex = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'roleDeleteGetAsync';
        let response = responseGet();
        try {
            //#region show message
            let msgTextObj = {
                one: `${labels?.role?.[languageObj?.id]}: <b>${description}</b><br/>`,
                two: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            let swalProperties = {
                icon: sweetAlert2?.icons?.warning,
                title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: sweetAlert2?.icons?.info,
                            title: `${messages?.processing?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.one}`,
                            showConfirmButton: false,
                        });

                        //#region delete countr
                        headerObj = {
                            headers: {
                                languageId: languageObj?.id,
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                            },
                            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlRoles}/${id}`
                        };

                        result = await axios.delete(
                            headerObj?.url,
                            headerObj,
                        );

                        response = result?.data || {};

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }
                        //#endregion delete country

                        //#region delete country (dataTable)
                        $(`#${dtRolesId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);
                        //#endregion delete country (dataTable)

                        //#region data set
                        setRole({});
                        setDtRowIndex(0);
                        //#endregion data set

                        await sendMessageCloseCurrentWindowAsync({
                            msgType: 0,
                            msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            await Swal.fire(swalProperties);
            //#endregion show message   
        } catch (ex) {
            setShowLoading({ building: false, coins: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion methods (roles)

    //#region methods (others)
    const dataGetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let dtRows = [];
            let isEditLocal = false;
            let isDeleteLocal = false;
            let rolesLocal = [roleModelGet({})];
            //#endregion variables

            //#region dataTable set
            response = dataTablesSet({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ roles: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion dataTable set

            //#region queryCode set
            response = queryCodeSet({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ roles: false, }); await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion queryCode set

            setShowLoading({ roles: true, });

            //#region data get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlRoles}/`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ roles: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            rolesLocal = response?.result || [];

            if (!isUndNullEmp({ data: rolesLocal, subMethod: currentMethod, })?.result && rolesLocal?.length > 0) {
                rolesLocal?.forEach((detail) => {
                    dtRows?.push([
                        detail?.description,
                        buttonProcessGet({
                            id: detail?.id,
                            description: detail?.description,
                            showDetails: false,
                            labelDetails: labels?.detail?.[languageObj?.id],
                            enabledDetails: false,
                            showEdit: true,
                            labelEdit: labels?.edit?.[languageObj?.id],
                            enabledEdit: true,
                            showDelete: true,
                            labelDelete: labels?.delete?.[languageObj?.id],
                            enabledDelete: processEvaluateGet({
                                object: detail,
                                property: labels?.process?.en?.toLowerCase(),
                                process: labels?.delete?.en?.toLowerCase(),
                                subMethod: currentMethod,
                            })?.result,
                            processButtons: [],
                        })?.result
                    ]);
                });
            }

            isEditLocal = (userRole === roles?.master || userRole === roles?.admin);
            isDeleteLocal = isEditLocal;
            setBtnAddDisable(!(isEditLocal && isDeleteLocal));
            //#endregion data get

            //#region load datatable
            $(`#${dtRolesId}`)?.DataTable()?.rows?.add(dtRows)?.draw(true);
            //#endregion load datatable

            setShowLoading({ roles: false, });
        } catch (ex) {
            setShowLoading({ roles: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataTablesSet = ({
        subMethod = '',
    }) => {
        let response = responseGet();
        try {
            $(`#${dtRolesId}`)?.DataTable({
                buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.description?.[languageObj?.id], width: '95%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                order: [[0, 'asc']],
            }).buttons().container().appendTo(`#${dtRolesId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const queryCodeSet = ({
        subMethod = '',
    }) => {
        const currentMethod = 'queryCodeSet';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region methods
            $(`#${dtRolesId} tbody`)?.on('click', 'tr', 'td', async function (e) {
                e.preventDefault();
                rowIndex = $(`#${dtRolesId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'edit':
                            roleEditGetAsync({ id: id, description: description, rowIndex: dtRowIndex, processType: 1, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            roleDeleteGetAsync({ id: id, description: description, rowIndex: dtRowIndex, processType: -1, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const controlsStatusSet = ({
        processType = 0,
        subMethod = '',
    }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.dataTables?.roles?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.roles?.buttons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.roles?.spinners?.add?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.roles?.icons?.add?.id}`)?.addClass(controls?.dataTables?.roles?.icons?.add?.className);
                    $(`#${controls?.dataTables?.roles?.buttons?.add?.id}`)?.addClass(controls?.dataTables?.roles?.buttons?.add?.className);
                    $(`#${controls?.dataTables?.roles?.spinners?.add?.id}`)?.addClass(controls?.dataTables?.roles?.spinners?.add?.className);


                    $(`#${controls?.dataTables?.roles?.icons?.delete?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.roles?.buttons?.delete?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.roles?.spinners?.delete?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.roles?.icons?.delete?.id}`)?.addClass(controls?.dataTables?.roles?.icons?.delete?.className);
                    $(`#${controls?.dataTables?.roles?.buttons?.delete?.id}`)?.addClass(controls?.dataTables?.roles?.buttons?.delete?.className);
                    $(`#${controls?.dataTables?.roles?.spinners?.delete?.id}`)?.addClass(controls?.dataTables?.roles?.spinners?.delete?.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.create?.id}`)?.addClass(`${reactHtml?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.dataTables?.roles?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.roles?.spinners?.add?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region old code
            // $(`#${controls?.inputs?.email?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.password?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.checkBox?.remenberMe?.id}`).attr('disabled', (processType !== 0));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            $(`#${controls?.dataTables?.roles?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.roles?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                $(`#${controls?.dataTables?.roles?.buttons?.add?.id}`)?.addClass(`${reactHtml?.button?.classes?.disabled}`);
                //$(`#${controls?.dataTables?.roles?.buttons?.delete?.id}`)?.addClass(`${reactHtml?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({
            subMethod: 'form - onLoad',
        });
    }, [auth]) // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='settings' process='roles' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.roles?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.roles?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='row'>
                            <div className='col-12'>

                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={reactHtml?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.roles}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.roles?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={images?.rolesLogo}></img> - {labels?.index?.[languageObj?.id]}
                                        </h6>
                                        {/* <div className='card-tools'>
                                            <button tooltip='tooltip' title={labels?.create?.[languageObj?.id]} className='btn btn-outline-success float-right btn-sm' onClick={() => roleAddGetAsync()}><i className={icons?.plusCircle}></i></button>
                                        </div> */}
                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div> {/*card header*/}

                                    <div className='card-body'>

                                        <div className='row'>
                                            {/* {!showLoading ? */}
                                            <div className='col-md-12'>
                                                {/* {showData ? */}
                                                {/* <div> */}
                                                {/* <button className='btn btn-outline-success float-right btn-sm'
                                                    disabled={btnAddDisable}
                                                    tooltip='tooltip'
                                                    title={labels?.create?.[languageObj?.id]}
                                                    onClick={() => roleAddGetAsync()}><i className={icons?.plusCircle}></i>
                                                </button> */}

                                                <button id={controls?.dataTables?.roles?.buttons?.add?.id}
                                                    className={controls?.dataTables?.roles?.buttons?.add?.className}
                                                    disabled={btnAddDisable}
                                                    tooltip='tooltip'
                                                    title={labels?.add?.[languageObj?.id]}
                                                    onClick={() => roleAddGetAsync({ subMethod: 'btn - roleAdd', })}>
                                                    <i id={controls?.dataTables?.roles?.icons?.add?.id} className={controls?.dataTables?.roles?.icons?.add?.className} /> <span id={controls?.dataTables?.roles?.spinners?.add?.id} className='' aria-hidden='true'></span>
                                                </button>

                                                <div className={html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtRolesId} className={html?.dataTables?.formats?.smStripedBordered}></table>
                                                </div>
                                                {/* </div> */}
                                                {/* : */}
                                                {/* <div></div> */}
                                                {/* } */}
                                            </div>
                                            {/* : */}
                                            {/* <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                                    width={40}
                                                    height={40}
                                                    color={colors?.infoColorExp}
                                                    msgText={messages?.processing?.[languageObj?.id]}
                                                    msgOrientation='text-center'
                                                    msgTextMuted={true} /> */}
                                            {/* } */}
                                        </div>

                                    </div> {/*card body*/}

                                    <div className='card-footer'>

                                    </div> {/*card footer*/}

                                </div>{/*card*/}

                            </div>{/*col*/}
                        </div>{/*row*/}

                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}

            </div>

            {showModal ?
                <RolesAddEdit $={$}
                    auth={auth}
                    showModal={showModal}
                    setShowModal={setShowModal}
                    role={role}
                    setRole={setRole}
                    dtId={dtRolesId}
                    dtRowIndex={dtRowIndex}
                    processType={processType}
                    languageObj={languageObj} />
                :
                <></>
            }
        </div>
    )
}